import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";
import { fetchApi } from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";

export const mapToDemandInFormat = mapDictionaryState;

const claimPersonalRelationshipApi = createDictionaryApiFactory("claimPersonalRelationship");

export const getClaimPersonalRelationship = claimPersonalRelationshipApi.search;
export const getClaimPersonalRelationshipDetail = claimPersonalRelationshipApi.getDetail;
export const createClaimPersonalRelationship = claimPersonalRelationshipApi.save;
export const exportCsvClaimPersonalRelationship= claimPersonalRelationshipApi.exportCsv;

export const getClaimPersonalRelationshipSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/claimPersonalRelationship/select`) as SelectItemDto[];
    return response;
};
